module.exports = {
    "es": {
        "info": [
            {
                "id": 0,
                active: true,
                "src": "/images/logos_payment/mit",
                "title": "payment.mit.title",
                "images": [
                    {
                        "name": "payment_visa",
                        "src": "/images/logos_payment/mit/visa",
                        "height": "20px"
                    },
                    {
                        "name": "payment_mastercard",
                        "src": "/images/logos_payment/mit/mastercard",
                        "height": "32px"
                    },
                    {
                        "name": "payment_amex",
                        "src": "/images/logos_payment/mit/amex",
                        "height": "32px"
                    },
                    {
                        "name": "payment_carnet",
                        "src": "/images/logos_payment/mit/carnet",
                        "height": "32px"
                    },
                    {
                        "name": "payment_diners_club",
                        "src": "/images/logos_payment/mit/diner",
                        "height": "32px"
                    },
                    {

                        "name": "payment_discover",
                        "src": "/images/logos_payment/mit/discover",
                        "height": "32px"
                    },
                    {
                        "name": "payment_clickpay",
                        "src": "/images/logos_payment/mit/clickpay",
                        "height": "32px"
                    },
                    {
                        "name": "payment_santander",
                        "src": "/images/logos_payment/mit/santander",
                        "height": "32px"
                    },
                    {
                        "name": "payment_scotiabank",
                        "src": "/images/logos_payment/mit/scotiabank",
                        "height": "32px"
                    },
                    {
                        "name": "payment_hsbc",
                        "src": "/images/logos_payment/mit/hsbc",
                        "height": "22px"
                    },
                    {
                        "name": "payment_banamex",
                        "src": "/images/logos_payment/mit/banamex",
                        "height": "32px"
                    },
                    {
                        "name": "payment_bbva",
                        "src": "/images/logos_payment/mit/bbva",
                        "height": "18px"
                    },
                    {
                        "name": "payment_banorte",
                        "src": "/images/logos_payment/mit/banorte",
                        "height": "32px"
                    },
                    {
                        "name": "payment_banbajio",
                        "src": "/images/logos_payment/mit/banbajio",
                        "height": "32px"
                    },
                    {
                        "name": "payment_invex",
                        "src": "/images/logos_payment/mit/invex",
                        "height": "18px"
                    },
                    {
                        "name": "payment_inbursa",
                        "src": "/images/logos_payment/mit/inbursa",
                        "height": "32px"
                    },
                    {
                        "name": "payment_banregio",
                        "src": "/images/logos_payment/mit/banregio",
                        "height": "20px"
                    },
                    {
                        "name": "payment_liverpool",
                        "src": "/images/logos_payment/mit/liverpool",
                        "height": "32px"
                    },
                    {
                        "name": "payment_bancoazteca",
                        "src": "/images/logos_payment/mit/bancoazteca",
                        "height": "28px"
                    },
                    {
                        "name": "payment_bajercito",
                        "src": "/images/logos_payment/mit/banjercito",
                        "height": "32px"
                    },
                    {
                        "name": "payment_afirme",
                        "src": "/images/logos_payment/mit/afirme",
                        "height": "28px"
                    },
                    {
                        "name": "payment_farabella",
                        "src": "/images/logos_payment/mit/farabella",
                        "height": "25px"
                    },
                    {
                        "name": "payment_konfio",
                        "src": "/images/logos_payment/mit/konfio",
                        "height": "18px"
                    },
                    {
                        "name": "payment_rappicard",
                        "src": "/images/logos_payment/mit/rappicard",
                        "height": "17px"
                    },
                    {
                        "name": "payment_bancafiel",
                        "src": "/images/logos_payment/mit/bancamifel",
                        "height": "32px"
                    },
                    {
                        "name": "payment_multiva",
                        "src": "/images/logos_payment/mit/multiva",
                        "height": "20px"
                    }
                ],
                "alt": "Pago con mit",
                "name": "mit"
            },
            {
                "id": 1,
                active: true,
                "src": "/images/reservation/logos/Banamex2",
                "title": "payment.banamex.title",
                "images": [
                    {
                        "name": "payment_visa",
                        "src": "/images/logos_payment/banamex/visa",
                        "height": "22px"
                    },
                    {
                        "name": "payment_mastercard",
                        "src": "/images/logos_payment/banamex/mastercard",
                        "height": "32px"
                    },
                    {
                        "name": "payment_banamex",
                        "src": "/images/logos_payment/banamex/banamex",
                        "height": "32px"
                    },
                    {
                        "name": "payment_bbva",
                        "src": "/images/logos_payment/banamex/bbva",
                        "height": "22px"
                    },
                    {
                        "name": "evo_payments",
                        "src": "/images/logos_payment/banamex/evopayments",
                        "height": "32px;"
                    },
                ],
                "alt": "Pago con Banamex cred",
                // "name": "mit"
                "name": "banamex"
            }
        ]
    }
}